var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "overview" }, [
    _vm.showCompanySelector
      ? _c(
          "div",
          { staticClass: "container__company-selector" },
          [
            _c("company-selector", {
              on: { companySelected: _vm.setSelectedCompany },
            }),
          ],
          1
        )
      : _c(
          "div",
          {
            staticClass:
              "columns is-multiline is-variable is-full is-margin-top-desktop",
          },
          [
            _c("div", { staticClass: "column is-half" }, [
              _c("div", { staticClass: "box white" }, [
                _c("h1", { staticClass: "title" }, [_vm._v("Latest Project")]),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _vm.projects[0]
                    ? _c(
                        "div",
                        {
                          staticClass: "column is-12 link",
                          on: {
                            click: function ($event) {
                              return _vm.setProject(_vm.projects[0])
                            },
                          },
                        },
                        [
                          _c("project-card", {
                            attrs: {
                              "project-details": _vm.projects[0],
                              "icon-type": _vm.getIconTypeForProject(
                                _vm.projects[0]
                              ),
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "column is-half hide-on-mobile" }, [
              _c(
                "div",
                { staticClass: "slider-container box" },
                [_c("ad-carousel")],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "column is-full" }, [
              _c("div", { staticClass: "projects-container" }, [
                _c("h1", { staticClass: "title title-line-middle" }, [
                  _vm._v("All Projects"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _vm.filteredProjects.length >= 1
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "columns is-multiline is-variable is-full",
                        },
                        _vm._l(_vm.filteredProjects, function (project) {
                          return _c(
                            "div",
                            {
                              staticClass: "link column is-6",
                              on: {
                                click: function ($event) {
                                  return _vm.setProject(project)
                                },
                              },
                            },
                            [
                              _c("project-card", {
                                attrs: {
                                  "project-details": project,
                                  "icon-type":
                                    _vm.getIconTypeForProject(project),
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _c(
                        "div",
                        {
                          staticClass:
                            "columns is-multiline is-variable is-full",
                        },
                        _vm._l(_vm.projects, function (project) {
                          return _c(
                            "div",
                            {
                              staticClass: "link column is-6",
                              on: {
                                click: function ($event) {
                                  return _vm.setProject(project)
                                },
                              },
                            },
                            [
                              _c("project-card", {
                                attrs: {
                                  "project-details": project,
                                  "icon-type":
                                    _vm.getIconTypeForProject(project),
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                ]),
              ]),
            ]),
          ]
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }